import React, {
    useImperativeHandle,
    forwardRef,
    useRef,
    ForwardRefRenderFunction,
  } from "react";
  
  export interface CommonTextEditorHandle {
    getContent: () => string;
  }
  
  const CommonTextEditor: ForwardRefRenderFunction<CommonTextEditorHandle> = (_, ref) => {
    const inputRef = useRef<HTMLTextAreaElement>(null);
  
    useImperativeHandle(ref, () => ({
      getContent: () => inputRef.current?.value || "",
    }));
  
    return (
      <textarea
        ref={inputRef}
        className="form-control"
        placeholder="Enter description"
        rows={5}
      />
    );
  };
  
  export default forwardRef(CommonTextEditor);
  